"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_button_1 = require("@saatva-bits/pattern-library.components.button");
const ProductFeatures_1 = __importDefault(require("../ProductFeatures"));
const FeatureTabs_module_scss_1 = __importDefault(require("./FeatureTabs.module.scss"));
/**
 * Renders tabs for the array of features from Prismic
 *
 * Allows switching between them
 */
const FeatureTabs = ({ modifier, featureArray, defaultIndex }) => {
    const [tab, switchTab] = (0, react_1.useState)(defaultIndex || 0);
    const { length } = featureArray;
    const { label, description, features } = featureArray[tab];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [length > 1 ? ((0, jsx_runtime_1.jsx)("div", { className: FeatureTabs_module_scss_1.default.tabButtons, children: featureArray.map((feature, i) => {
                    const buttonClasses = (0, classnames_1.default)(FeatureTabs_module_scss_1.default.tabButton, {
                        [FeatureTabs_module_scss_1.default[`${modifier}Button`]]: modifier,
                        [FeatureTabs_module_scss_1.default['tabButton-active']]: feature.label === label
                    });
                    return ((0, jsx_runtime_1.jsx)(pattern_library_components_button_1.Button, { className: buttonClasses, onClick: () => switchTab(i), children: feature.label }, feature.label));
                }) })) : (0, jsx_runtime_1.jsx)("h3", { children: label }), description && (0, jsx_runtime_1.jsx)("p", { children: description }), features && (0, jsx_runtime_1.jsx)(ProductFeatures_1.default, { features: features })] }));
};
FeatureTabs.propTypes = {
    modifier: prop_types_1.default.string,
    defaultIndex: prop_types_1.default.number,
    featureArray: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.string,
        description: prop_types_1.default.string,
        features: prop_types_1.default.node
    }))
};
exports.default = FeatureTabs;
//# sourceMappingURL=FeatureTabs.js.map